/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from '../hooks/useValidation';
import useFlowContext from "../hooks/useFlowContext";

export default function FlowFieldFile(props) {
    const { colClassName, field, component, path, id, addFiles, removeFiles } = props;
    const { type, label, required, disabled, placeholder = null, value, name, multiple } = field;
    const files = component?.metadata?.[name];

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const {
        translate = () => {},
    } = useFlowContext();

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <Form.File
                    custom
                    className={`${error ? 'is-error' : ''}`}
                    name={id}
                    label={files?.length > 0 ? files.map((file) => file.name).join(', ') : label}
                    {...{
                        required,
                        disabled,
                        multiple,
                        placeholder,
                    }}
                    onChange={(e) => {
                        const files = e?.target?.files;

                        removeFiles(value, () => {
                            addFiles(files, () => {
                                trigger(path);
                            });
                        });
                    }}
                />
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
